import { Link, Text } from '@stitch-fix/mode-react';
interface CorrectedQueryProps {
  correction: string;
}
const CorrectedQuery = ({
  correction
}: CorrectedQueryProps) => <Text setting="body-small" align={{
  sm: 'left',
  md: 'center'
}} mb={0.5}>
    Did you mean&nbsp;
    <Link href={`/search/?q=${correction}`}>{correction}</Link>?
  </Text>;
export default CorrectedQuery;